import styled, { css } from "styled-components";

const AddElementStyled = styled.button`
    cursor: pointer;
    text-align: right;
    > span {
        color: ${props => props.theme.lightGreen};
        font-size: 1.4rem;
		font-family: ${props => props.theme.fontBold};
        span {
            padding-right: 0.5rem;
        }

		@media only screen and (min-width: ${props => props.theme.tablet}) {
			font-size: 1.6rem;
		}
    }
    ${props => {
        return (
            props.disabled &&
            css`
               > span {
                   color: ${props.theme.lightGray5};
               } 
            `
        );
    }}
`;

export default AddElementStyled;
